export default {
  color: {
    body: {
      background: "#f5f5f5",
    },
    font: {
      primary: "#6351ed",
    },
    border: {
      primary: "#e1e1e1",
      secondary: "#e5e5e5",
    },
  },
};
